module.exports = __webpack_public_path__ + "static/media/community.6896bbfa.svg";